import type { WebGLRenderer } from '@seddi/three';
import { v4 as uuid } from 'uuid';

import type { ResourcesContext } from './resources/resourcesContext';
import type { SceneViewerConfig } from './sceneViewerConfig';
import { type SceneViewerContext, create as createContext } from './sceneViewerContext';

export type MultiViewElement = SceneViewerContext & {
  readonly domElement: HTMLElement;
  readonly id: string;
};

export const create = (
  renderer: WebGLRenderer,
  resources: ResourcesContext,
  domElement: HTMLElement,
  config: Partial<SceneViewerConfig>,
): MultiViewElement => {
  const context = createContext(renderer, resources, config);
  const id = uuid();
  return { ...context, domElement, id };
};

/**
 * Get its position relative to the page's viewport.
 * @param self
 */
export const getBoundingClientRect = (self: MultiViewElement) => {
  return self.domElement.getBoundingClientRect();
};
